<template>
  <v-card class="teacher-basic-info pa-3">
    <v-card-title class="pb-0">
      <div>
        <h2>Update your School Information</h2>
        <p>Update your school details here.</p>
      </div>
      <v-spacer />
      <v-btn
        :color="edit ? 'error' : 'primary'"
        @click="edit = !edit"
        :loading="loading"
      >
        <v-icon class="pr-2">{{ edit ? 'close' : 'edit' }}</v-icon>
        {{ edit ? 'cancel' : 'Edit' }}
      </v-btn>
    </v-card-title>
    <v-card-text v-if="me">
      <v-row>
        <v-col cols="12" class="pr-2">
          <v-select
            v-model="me.role"
            label="Current role"
            :disabled="edit"
            :items="roles"
            readonly
          ></v-select>
          <v-text-field
            :value="institutionValue"
            label="Current Institution"
            :disabled="edit"
            readonly
          />
        </v-col>
        <v-col cols="12">
          <v-card v-show="edit" :disabled="loading">
            <v-card-title primary-title>
              <v-icon class="pr-2">info</v-icon> Enter updated role and school
            </v-card-title>
            <v-card-text>
              <role-info ref="roleInfo" v-model="roleInfo" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        v-if="edit"
        color="primary"
        @click="submit"
        :loading="loading"
        class="button_google_tag_manager"
        data-category="user"
        data-action="click"
        data-label="update profile"
      >
        Update
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import RoleInfo from '@/components/roleinfo/RoleInfo'
import Auth from '@/modules/auth/models/Auth'
import { mapMutations } from 'vuex'

export default {
  name: 'SchoolInfo',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    RoleInfo
  },
  data() {
    return {
      roleInfo: null,
      edit: false,
      loading: false,
      roles: [
        {
          text: 'Teacher',
          value: 'teacher'
        },
        {
          text: 'Casual Teacher',
          value: 'casual'
        },
        {
          text: 'School Leader / Principal',
          value: 'school_leader_principal'
        },
        {
          text: 'School Admin',
          value: 'school_admin'
        },
        {
          text: 'Home school / Distance Educator',
          value: 'home_distance'
        },
        {
          text: 'Pre-service Teacher',
          value: 'pre_service_teacher'
        },
        {
          text: 'Organization / Company',
          value: 'organization_company'
        },
        {
          text: 'Other',
          value: 'other'
        }
      ]
    }
  },
  computed: {
    me() {
      return Auth.query()
        .where('type', this.$route.meta.type)
        .first()
    },
    institutionValue() {
      if (this.me && this.me.school_name) {
        return this.me.school_name
      } else if (
        this.me &&
        this.me.school_metadata &&
        this.me.school_metadata.school_text
      ) {
        return this.me.school_metadata.school_text
      }

      return ''
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showErrorSnackbar', 'showSnackbar']),
    async submit() {
      // validate form
      let result = await this.$refs.roleInfo.validate()
      if (!result) return // there are errors

      const payload = {}

      if (this.roleInfo) {
        payload.role = this.roleInfo.role
        payload.postcode = this.roleInfo.postcode
        payload.school_text = this.roleInfo.name
        payload.state = this.roleInfo.state

        if (this.roleInfo.country) {
          payload.country = this.roleInfo.country
        }

        if (this.roleInfo.school) {
          payload.acara_id = this.roleInfo.school.value
          payload.school_name = this.roleInfo.school.text
        }
      }

      try {
        this.loading = true
        await Auth.dispatch('updateProfile', {
          payload: payload,
          type: 'teachers'
        })
        this.loading = false
        this.edit = false
        this.$refs.roleInfo.reset()
        this.showSnackbar('Updated successfully.')
      } catch (error) {
        this.loading = false
        this.edit = false
        this.showErrorSnackbar('There was an error.')
      }
    }
  }
}
</script>

<style lang="scss">
.teacher-basic-info {
  h2 {
    display: block;
    width: 100%;
    font-size: 1em;
  }

  p {
    padding: 0;
    margin: 0;
    font-size: 1rem;
  }
}
</style>
